module.exports = __webpack_public_path__ + "b.no2.46486102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/b.no2.jpg
// module id = HEke
// module chunks = 0